import { render, staticRenderFns } from "./StatusDuration.vue?vue&type=template&id=2ec00c57&scoped=true"
import script from "./StatusDuration.vue?vue&type=script&lang=js"
export * from "./StatusDuration.vue?vue&type=script&lang=js"
import style0 from "./StatusDuration.vue?vue&type=style&index=0&id=2ec00c57&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec00c57",
  null
  
)

export default component.exports